export const current_status = [
        {
            label: 'Bán',
            value: 'Bán'
        },
        {
            label: 'Thuê',
            value: 'Thuê'
        },
        {
            label: 'Bán và Thuê',
            value: 'Bán và Thuê'
        },
        {
            label: 'Đang cho thuê - Có hạn HĐ',
            value: 'Đang cho thuê - Có hạn HĐ'
        },
        {
            label: 'Đang cho thuê - Không hạn HĐ',
            value: 'Đang cho thuê - Không hạn HĐ'
        },
        {
            label: 'Bán khác',
            value: 'Bán khác'
        },
        {
            label: 'Thuê khác',
            value: 'Thuê khác'
        },
        {
            label: 'Tìm mua',
            value: 'Tìm mua'
        },
        {
            label: 'Tìm thuê',
            value: 'Tìm thuê'
        },
        {
            label: 'Tìm mua khác',
            value: 'Tìm mua khác'
        },
        {
            label: 'Tìm thuê khác',
            value: 'Tìm thuê khác'
        },
        {
            label: 'Ở',
            value: 'Ở'
        },
        {
            label: 'Đã bán',
            value: 'Đã bán'
        },
        {
            label: 'Không nghe',
            value: 'Không nghe'
        },
        {
            label: 'Không có nhu cầu',
            value: 'Không có nhu cầu'
        },
        {
            label: 'Lỗi/Sai thông tin',
            value: 'Lỗi/Sai thông tin'
        },
        {
            label: 'Lỗi hệ thống',
            value: 'Lỗi hệ thống'
        },
]

export const status = [
    {
        label: 'Có',
        value: 'Có'
    },
    {
        label: 'Đang',
        value: 'Đang'
    },
    {
        label: 'Chưa',
        value: 'Chưa'
    },
    {
        label: 'Triển khai',
        value: 'Triển khai'
    },
]